document.addEventListener("DOMContentLoaded", () => {
  initProductSlider();  
});

  function initProductSlider() {

    const sliders = document.querySelectorAll(".slider__inner-wrapper");  
    
  sliders.forEach((slider) => {
    const sliderContainer = slider.closest(".slider__box");
    const prevButton = sliderContainer.querySelector(".slider__prev");
    const nextButton = sliderContainer.querySelector(".slider__next");
    const productList = slider.querySelector(".product-slider");
    const productListChild = slider.querySelector(".slider__product-card");
    const products = productList ? Array.from(productList.children) : [];    
    const relatedSection = sliderContainer.parentElement;

    const setDimensions = () => {
    if(window.innerWidth >= 990){
    if (products.length > 4) {
      productList.classList.remove("less-than-four");
      productList.classList.add("more-than-four");
      } else {
        productList.classList.remove("more-than-four");
        productList.classList.add("less-than-four");      
      }
      if (products.length == 4) {
          productList.style.justifyContent = "space-between";
      }else if(products.length <= 3){
        productList.style.justifyContent = "start";
        productList.style.gap = "18px";
      }else{
        productList.style.justifyContent = "unset";
      }
    } else {
      if (products.length > 2) {
        productList.classList.remove("less-than-four");
        productList.classList.add("more-than-four");
      } else {
        productList.classList.remove("more-than-four");
        productList.classList.add("less-than-four");      
      }
      if (products.length == 2) {
          productList.style.justifyContent = "space-between";
      }else if(products.length <= 1){
        productList.style.justifyContent = "start";
        productList.style.gap = "18px";
      }else{
        productList.style.justifyContent = "unset";
      }
  }
}   

  const reloadSection = (slider) => {    
    const sliderId = productList.id;
    const variantId = slider.getAttribute('variant');
    const id = slider.getAttribute('section');  
      
    fetch(`${window.location.pathname}?section_id=${id}&variant=${variantId}`)
      .then(response => response.text())
      .then(html => {
        const newContent = new DOMParser().parseFromString(html, "text/html").getElementById(`${sliderId}`);        
        if (newContent) {
          productList.innerHTML = newContent.innerHTML;
          requestAnimationFrame(() => {
          setDimensions();  
          handleDesktopBehavior();  
          });
        }
      })
      .catch(error => console.error("Fehler beim Neuladen der Section:", error));    
  }

    
    if (products.length < 1) {
      console.error("Keine Produkte gefunden!");
      return;
    }
    
    const handleDesktopBehavior = () => {     
      const products = productList ? Array.from(productList.children) : [];  
      
      if (products.length <= 4 && window.innerWidth >= 990) {
        prevButton.style.display = "none";
        nextButton.style.display = "none";   
        slider.style.overflowX = "hidden";
        productList.style.overflowX = "hidden"; 
      }else if(products.length <= 2 && window.innerWidth < 990){
        prevButton.style.display = "none";
        nextButton.style.display = "none";    
        slider.style.overflowX = "hidden";
        productList.style.overflowX = "hidden"; 
      } else {
        prevButton.style.display = "flex";
        nextButton.style.display = "flex";
        slider.style.overflowX = "auto";
        productList.style.overflowX = "auto"; 

        const firstClone = products.map((product) => product.cloneNode(true));
        const lastClone = products.map((product) => product.cloneNode(true));

        firstClone.forEach((clone) => productList.appendChild(clone));
        lastClone
          .reverse()
          .forEach((clone) =>
            productList.insertBefore(clone, productList.firstChild)
          );

       const productWidth = products[0].offsetWidth;
       productList.scrollLeft = productWidth * products.length;

       const scrollSlider = (direction) => {
          const productWidth =
            products[0].offsetWidth +
            parseInt(getComputedStyle(productListChild).marginRight || 0) + parseInt(getComputedStyle(productListChild).borderRightWidth || 0);
          productList.scrollBy({
            left: direction === "left" ? -productWidth : productWidth,
            behavior: "smooth",
          });
        };

        prevButton.addEventListener("click", () => scrollSlider("left"));
        nextButton.addEventListener("click", () => scrollSlider("right"));

        productList.scrollLeft = productWidth;

      productList.addEventListener("scroll", () => {
        const scrollPosition = productList.scrollLeft;
        const maxScroll = productList.scrollWidth - productList.offsetWidth;
      
        if (scrollPosition <= 0) {
          productList.scrollLeft = maxScroll - productWidth;
        } else if (scrollPosition >= maxScroll - productWidth) {
          productList.scrollLeft = productWidth;
        }
      });
      }
    };

     const resize = () => {       
      reloadSection(slider); 
      console.log(productList.scrollLeft);
    }  
    
    setDimensions();  
    handleDesktopBehavior();  
    
    window.addEventListener("resize", resize);
  });
  }